import { interpolator } from '@fiverr-private/futile';

/** @param {number} value */
export const getInUsd = (value) => `$${value}`;

const interpolate = interpolator(/{{([^{}]*)}}/g);

/**
 * @param {string} template
 * @param {number} amount
 * @returns {string}
 */
export const interpolateTemplate = (template, amount) => interpolate(template, { amount });
